/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { styles } from "./styles";
import { TextField, Box, Button, Typography } from "@material-ui/core";
import { isIE } from "react-device-detect";
import { News } from "../../shared";
import { useNews } from "../../shared";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { KeyboardDatePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const CAPTION_KEY = "caption";
const DATE_KEY = "date";
const DESCRIPTION_KEY = "description";

type OwnProps = {
  onClose: () => void;
  itemToEdit: News | null;
};

type Props = OwnProps & WithStyles<typeof styles>;

const NewsInputForm: React.FC<Props> = (props: Props) => {
  const { itemToEdit, onClose } = props;

  const initialDate = itemToEdit ? new Date(itemToEdit.createdDate) : new Date();
  const initialCaption = itemToEdit ? itemToEdit.caption : "";
  const initialDescription = itemToEdit ? itemToEdit.description : "";

  const [createdDate, setDate] = React.useState<Date>(initialDate);
  const [caption, setCaption] = React.useState<string>(initialCaption);
  const [description, setDescription] = React.useState<string>(initialDescription);
  const [isDirtyForm, setIsDirtyForm] = React.useState<boolean>(false)
  const [, , addNews, changeNews] = useNews();

  const handleApply = () => {
    if (itemToEdit) {
      changeNews({ ...itemToEdit, caption, description, createdDate: createdDate.toDateString() });
    } else {
      addNews(caption, description, createdDate.toDateString());
    }
    onClose();
  };

  const handleChange = (id: string) => (e: any) => {
    let value;
    switch (id) {
      case CAPTION_KEY:
        value = e.target.value;
        setCaption(value);
        break;
      case DESCRIPTION_KEY:
        value = e.target.value;
        setDescription(value);
        break;
      case DATE_KEY:
        value = e;
        setDate(value);
        break;
    }
    setIsDirtyForm(true)
  }

  const { classes } = props;
  const headerMessage = itemToEdit ? messages.headerEdit : messages.headerAdd
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Box className={classes.root}>
        <Typography className={classes.header}>
          <FormattedMessage {...headerMessage} />
        </Typography>
        <div className={classes.inputRoot}>
          <div className={classes.inputItem}>
            <TextField
              name="titleNews"
              variant="outlined"
              fullWidth
              id="titleNews"
              label={<FormattedMessage {...messages.title} />}
              className={classes.textField}
              InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
              value={caption}
              onChange={handleChange(CAPTION_KEY)}
            />
          </div>
          <div className={classes.inputItem}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Date picker inline"
              value={createdDate}
              onChange={handleChange(DATE_KEY)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </div>
          <div className={classes.inputItem}>
            <TextField
              name="descriptionNews"
              variant="outlined"
              fullWidth
              id="descriptionNews"
              label={<FormattedMessage {...messages.description} />}
              className={classes.textField}
              InputLabelProps={{ classes: { root: classes.inputLabel }, shrink: isIE ? true : undefined }}
              value={description}
              multiline
              rows={4}
              onChange={handleChange(DESCRIPTION_KEY)}
            />
          </div>
        </div>
        <div className={classes.buttonBase}>
          <Button className={classes.button} color="primary" variant="contained" onClick={handleApply} disabled={!isDirtyForm || !(Boolean(caption) && Boolean(description))}>
            <FormattedMessage {...messages.btnApply} />
          </Button>
          <Button className={classes.button} color="secondary" variant="contained" onClick={onClose}>
            <FormattedMessage {...messages.btnCancel} />
          </Button>
        </div>
      </Box>
    </MuiPickersUtilsProvider>
  );
};

export default withStyles(styles)(NewsInputForm);
